module.exports.PageController = require('./PageController')
module.exports.HomepageController = require('./HomepageController')
module.exports.NotFoundController = require('./NotFoundController')
module.exports.GameController = require('./GameController')
module.exports.OnboardingController = require('./OnboardingController')
module.exports.VRController = require('./VRController')
module.exports.CodeController = require('./CodeController')
module.exports.LooksController = require('./LooksController')
module.exports.GridPresetController = require('./GridPresetController')
module.exports.GridDefaultController = require('./GridDefaultController')
module.exports.GameWaitController = require('./GameWaitController')
module.exports.GameErrorController = require('./GameErrorController')
module.exports.GameOverloadController = require('./GameOverloadController')
module.exports.VideoController = require('./VideoController')
